module.exports = __webpack_public_path__ + "img/p2.bab47279.svg";